import React from 'react';
// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap/dist/js/bootstrap"
import './App.css';
import Error from './Components/Error';

import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './Components/Navbar/Navbar';
import Home from './Components/Pages/Home';
import Products from './Components/Pages/Products';
import Contact from './Components/Pages/Contact';
import About from './Components/Pages/About';
import Services from './Components/Pages/Services';
import ServicesHome from './Components/Pages/ServicesHome';
import ServiceCaseStudyPage from './Components/Pages/ServiceCaseStudyPage';
import Policy from './Components/Pages/Policy';
import Footer from './Components/Footer';

 function App() {
//   useEffect(() => {
//       (async () => await initSatellite())();
//     }
// , []);

  return (
    <>
    <Router>
      <Navbar/>
      <Routes>
        <Route path='/' exact element={<Home/>}/>
        <Route path='/products' element={<Products/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/services' element={<Services />}>
          <Route index element={<ServicesHome />} />
          <Route path="case-studies/:slug" element={<ServiceCaseStudyPage />} />
        </Route>
        <Route path='/policy' element={<Policy/>}/>
        <Route path="*" element={<Error/>}/>
      </Routes>
      <Footer/>
    </Router>
    </>

    
    
  );
}

export default App;
